<template>
  <div class="par-toolbar">
    <div class="par-search-wrap">
      <i class="fa-solid fa-magnifying-glass par-search-icon" aria-hidden="true" />
      <input
        :value="search"
        type="search"
        class="par-search-input"
        placeholder="Search by name, brand, or description…"
        aria-label="Search paralympic equipment"
        @input="$emit('update:search', $event.target.value)"
      />
      <button
        v-if="search"
        type="button"
        class="par-search-clear"
        aria-label="Clear search"
        @click="$emit('update:search', '')"
      >
        <i class="fa-solid fa-xmark" />
      </button>
    </div>

    <div class="par-filter-row" role="tablist" aria-label="Equipment categories">
      <button
        type="button"
        class="par-chip"
        :class="{ active: categoryCode === null }"
        @click="$emit('update:categoryCode', null)"
      >
        All categories
      </button>
      <button
        v-for="cat in categories"
        :key="cat.code"
        type="button"
        class="par-chip"
        :class="{ active: categoryCode === cat.code }"
        @click="$emit('update:categoryCode', cat.code)"
      >
        {{ cat.name }}
      </button>
    </div>

    <div
      v-if="typeOptions.length"
      class="par-filter-row par-filter-row--types"
      role="tablist"
      aria-label="Equipment types"
    >
      <button
        type="button"
        class="par-chip"
        :class="{ active: typeCode === null }"
        @click="$emit('update:typeCode', null)"
      >
        All types
      </button>
      <button
        v-for="t in typeOptions"
        :key="t.code"
        type="button"
        class="par-chip"
        :class="{ active: typeCode === t.code }"
        @click="$emit('update:typeCode', t.code)"
      >
        {{ t.name }}
      </button>
    </div>

    <div class="par-toggle-filters">
      <label>
        <input
          type="checkbox"
          :checked="inStockOnly"
          @change="$emit('update:inStockOnly', $event.target.checked)"
        />
        In stock only
      </label>
      <label>
        <input
          type="checkbox"
          :checked="needsFitting"
          @change="$emit('update:needsFitting', $event.target.checked)"
        />
        Needs fitting
      </label>
      <label>
        <input
          type="checkbox"
          :checked="fitterOnly"
          @change="$emit('update:fitterOnly', $event.target.checked)"
        />
        Certified fitter items
      </label>
    </div>

    <p v-if="resultCount !== null" class="par-results-meta">
      {{ resultCount }} item{{ resultCount === 1 ? "" : "s" }} found
    </p>
  </div>
</template>

<script>
import { PARALYMPIC_CATEGORIES, typesForCategory } from "@/constants/paralympicCatalogue";

export default {
  name: "ParalympicEquipmentToolbar",
  props: {
    search: { type: String, default: "" },
    categoryCode: { type: Number, default: null },
    typeCode: { type: Number, default: null },
    inStockOnly: { type: Boolean, default: false },
    needsFitting: { type: Boolean, default: false },
    fitterOnly: { type: Boolean, default: false },
    resultCount: { type: Number, default: null },
  },
  emits: [
    "update:search",
    "update:categoryCode",
    "update:typeCode",
    "update:inStockOnly",
    "update:needsFitting",
    "update:fitterOnly",
  ],
  data() {
    return { categories: PARALYMPIC_CATEGORIES };
  },
  computed: {
    typeOptions() {
      return typesForCategory(this.categoryCode);
    },
  },
};
</script>

<style scoped src="./paralympicStore.css"></style>
